import { httpClient } from './httpClient'
import type { ZipRequest } from '@/models/library'

export const exportApi = {
  /** Requests a zip archive and returns the blob plus a suggested file name. */
  async zip(request: ZipRequest): Promise<{ blob: Blob; fileName: string }> {
    const response = await httpClient.post('/api/export/zip', request, {
      responseType: 'blob'
    })

    const disposition = response.headers['content-disposition'] as string | undefined
    const match = disposition?.match(/filename="?([^"]+)"?/i)
    const fileName = match?.[1] ?? 'scans.zip'

    return { blob: response.data as Blob, fileName }
  }
}
